import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/sell-my-rv")({
  head: () => pageHead({ title: 'Sell or Trade Your RV', description: 'Get a fast offer for your RV at Rex & Sons RVs. We buy used motorhomes, travel trailers and fifth wheels.', path: '/sell-my-rv' }),
  beforeLoad: () => {
    throw redirect({ href: "/sell-your-rv" });
  },
});
